import client from '@/config/directus.api';

const COLLECTION = 'w2p_templates';

/**
 * Get templates
 */
export function getTemplates() {
  return client
    .getItems(COLLECTION, {
      fields: ['*.*']
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get templates details
 *
 */
export function getTemplatesDetails() {
  return client
    .getItems('w2p_templatedetails', {
      fields: ['*', 'templatecategory.*', 'template_type.*', 'image.*']
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get template details by design id
 *
 * @param {int} id
 */
export function getTemplateDetailsById(id) {
  return client
    .getItems('w2p_templatedetails', {
      fields: ['*', 'template.*', 'template_type.*'],
      filter: {
        'template.design_id': id
      },
      single: true
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get template category details
 *
 */
export function getTemplateCategoryDetails() {
  return client
    .getItems('w2p_templatecategories_details', {
      fields: ['*', 'templatecategory.*', 'image.*']
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}
